
import TextInput from '../../inputs/TextInput'
import Setting from '../Setting'
import SettingActions from '../SettingActions'

export default {
    name: 'PasswordUpdate',
    components: {
        TextInput,
        Setting,
        SettingActions
    },
    data () {
        return {
            state: 'show',
            form: new this.$vForm({
                password: '',
                new_password: '',
                new_password_confirmation: ''
            })
        }
    },
    watch: {
        async state (value) {
            if (value === 'show') {
                this.form.password = ''
                this.form.new_password = ''
                this.form.new_password_confirmation = ''
            }

            if (value === 'submit') {
                try {
                    await this.form.submit('post', '/v1/settings/updatePassword')
                    this.success()
                    this.state = 'show'
                } catch (e) {
                    this.failed(e)
                    this.state = 'edit'
                }
            }
        }
    },
    methods: {
        success () {
            this.$refs.settings.alert({
                type: 'success',
                body: this.$t('successfully updated')
            })
        },
        failed (e) {
            if (!e.response || e.response.status >= 500) {
                this.$emit('alert', {
                    type: 'danger',
                    body: this.$t('general error please try again')
                })
            }
        }
    }
}
